(function () {
  'use strict';

  // v-store-roll="text" renders an already formatted value and rolls only the
  // digit columns that changed (old digit to new digit, never counting through
  // intermediate values). It is presentation only: the bound text is shown
  // exactly as given, instantly under reduced motion or without WAAPI.
  // Pass { text, animate: false } to update without motion.
  var DURATION = 560;
  var STAGGER = 28;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function normalize(value) {
    if (value && typeof value === 'object') {
      return { text: value.text == null ? '' : String(value.text), animate: value.animate !== false };
    }
    return { text: value == null ? '' : String(value), animate: true };
  }

  function stop(element) {
    (element._storeRollAnimations || []).forEach(function (animation) {
      try { animation.cancel(); } catch (_) {}
    });
    element._storeRollAnimations = null;
  }

  function plain(element, text) {
    element.textContent = text;
  }

  function roll(element, previous, text) {
    var up = parseFloat(text.replace(/[^\d.]/g, '')) >= parseFloat(previous.replace(/[^\d.]/g, ''));
    var columns = '';
    for (var index = 0; index < text.length; index++) {
      var next = text[index];
      var old = previous[previous.length - (text.length - index)] || '';
      if (/\d/.test(next) && old !== next && (old === '' || /\d/.test(old))) {
        var from = old === '' ? ' ' : old;
        columns += '<span class="store-roll__col"><span class="store-roll__reel" data-rank="' + (text.length - 1 - index) + '">' +
          (up ? '<span>' + from + '</span><span>' + next + '</span>' : '<span>' + next + '</span><span>' + from + '</span>') +
          '</span></span>';
      } else {
        columns += '<span class="store-roll__fix">' + (next === ' ' ? '&nbsp;' : next.replace(/[<>&]/g, '')) + '</span>';
      }
    }
    element.innerHTML = '<span class="store-roll__sr"></span><span class="store-roll__digits" aria-hidden="true">' + columns + '</span>';
    element.firstChild.textContent = text;
    var frames = up
      ? [{ transform: 'translateY(0)' }, { transform: 'translateY(-1.15em)' }]
      : [{ transform: 'translateY(-1.15em)' }, { transform: 'translateY(0)' }];
    element._storeRollAnimations = Array.prototype.map.call(element.querySelectorAll('.store-roll__reel'), function (reel) {
      return reel.animate(frames, {
        duration: DURATION,
        delay: Number(reel.getAttribute('data-rank')) * STAGGER,
        easing: 'cubic-bezier(.2,0,0,1)',
        fill: 'both',
      });
    });
    Promise.all(element._storeRollAnimations.map(function (animation) { return animation.finished; }))
      .then(function () {
        if (element._storeRollText !== text) return;
        element._storeRollAnimations = null;
        plain(element, text);
      })
      .catch(function () {});
  }

  function render(element, binding, first) {
    var value = normalize(binding.value);
    var previous = element._storeRollText;
    if (!first && previous === value.text) return;
    stop(element);
    element._storeRollText = value.text;
    var canAnimate = !first && value.animate && previous && /\d/.test(previous) && /\d/.test(value.text) &&
      !(reduceMotion && reduceMotion.matches) && typeof element.animate === 'function';
    if (canAnimate) roll(element, previous, value.text);
    else plain(element, value.text);
  }

  Vue.directive('store-roll', {
    bind: function (element, binding) {
      element.classList.add('store-roll');
      render(element, binding, true);
    },
    update: function (element, binding) { render(element, binding, false); },
    unbind: function (element) { stop(element); },
  });
})();
